import {
  makeObservable,
  observable,
  action,
  computed,
  runInAction
} from 'mobx';
import dayjs from 'dayjs';
import i18n from 'src/i18n';

import signInViewModel from 'src/components/Header/component/SignIn/viewModel';
import Player from 'src/components/Player/viewModel';
import ChapterService from 'src/services/chapter';
import ChapterError from 'src/services/error/models/chapter';

import { SuccessToast, ErrorToast } from 'src/libs/toast';

export default class ChapterCardViewModel {
  @observable id;
  @observable courseId;
  @observable title;
  @observable type;
  @observable duration;
  @observable popularity;
  @observable createdAt;
  @observable isFavorite;
  @observable isLastLearned;
  @observable isTrial;
  @observable isPurchaseOnly;
  @observable isOwned;
  @observable lastAt;
  @observable document;

  @observable isProcessing = false;

  constructor(data) {
    makeObservable(this);
    this.deserialize(data);
  }

  @action
  deserialize = (data) => {
    this.id = data.id;
    this.courseId = data.courseId;
    this.courseName = data.courseName;
    this.title = data.name;
    this.type = data.type;
    this.duration = data.duration;
    this.popularity = data.popularity;
    this.createdAt = data.createdAt;
    this.isFavorite = data.isFavorite;
    this.isTrial = data.isTrial;
    this.isPurchaseOnly = data.saleType === 'Single';
    this.isOwned = data.isOwned;
    this.lastAt = data.lastAt;
    this.priority = data.priority;
    this.document = data.document;
  };

  @action
  onFavoriteClick = async (uid) => {
    try {
      if (!uid) {
        SuccessToast(i18n.t('common_login_unlock'));
        setTimeout(() => {
          signInViewModel.handleOpen();
        }, 500);
        return;
      }
      this.isProcessing = true;
      const res = await ChapterService.changeIsFavorite(uid, this.id);
      runInAction(() => {
        this.isFavorite = res.isFavorite;
        if (this.isFavorite) {
          SuccessToast(i18n.t('course_favorite_add'));
        } else {
          ErrorToast(i18n.t('course_favorite_remove'));
        }
        this.isProcessing = false;

        // 修改播放器的收藏.
        Player.setFavorite({
          id: this.id,
          isFavorite: res.isFavorite
        });
      });
    } catch (error) {
      ChapterError.changeIsFavorite(error);
      this.isProcessing = false;
    }
  };

  @action
  onControllerClick = (openModalFunction, profile, router = {}) => {
    if (
      this.isTrial
      || this.isOwned
      || (!this.isPurchaseOnly && !!(profile && profile?.group === 'Subscriber'))
    ) {
      if (this.type === 'Document') {
        router.navigate(`/course/${this.courseId}/chapter/${this.id}`);
        return;
      }
      Player.handlerSetChapterId({ chapterId: this.id });
      // NOTE: move all status related func to player.
    } else {
      openModalFunction(this.isPurchaseOnly ? this.courseId : null);
    }
  };

  @action
  changeOnPlay = () => {
    this.lastAt = 0;
  }

  @action
  setIsFavorite = (isFavorite) => {
    this.isFavorite = isFavorite;
  };

  @computed
  get lengthCT() {
    const hours = Math.floor(this.duration / 3600) || null;
    const hoursText = hours && (hours >= 10 ? hours : `0${hours}`);

    if (hoursText) {
      const minutesWithHour = Math.floor((this.duration - hours * 3600) / 60);
      const minutesWithHourText = minutesWithHour >= 10 ? minutesWithHour : `0${minutesWithHour}`;
      return `${hoursText} 時 ${minutesWithHourText} 分`;
    }

    const minutes = Math.floor(this.duration / 60);
    const minutesText = minutes >= 10 ? minutes : `0${minutes}`;
    const seconds = this.duration - minutes * 60;
    const secondsText = seconds >= 10 ? seconds : `0${seconds}`;

    return `${minutesText} 分 ${secondsText} 秒`;
  }

  @computed
  get isLatest() {
    const today = dayjs();
    const releaseTime = dayjs(this.createdAt);
    return today.diff(releaseTime, 'day') <= 14;
  }
}
